import GymIcon from '@mui/icons-material/FitnessCenter';
import PoolIcon from '@mui/icons-material/Pool';
import SportsTennis from '@mui/icons-material/SportsTennis';
import Jacuzzi from '@mui/icons-material/HotTub';
import Park from '@mui/icons-material/Nature';
import SportsBasketball from '@mui/icons-material/SportsBasketball';
import GolfCourse from '@mui/icons-material/GolfCourse';
import Walk from '@mui/icons-material/DirectionsWalk';
import SportsVolleyball from '@mui/icons-material/SportsVolleyball';
import SportsBaseball from '@mui/icons-material/SportsBaseball';
import SportsSoccer from '@mui/icons-material/SportsSoccer';
import BeachAccess from '@mui/icons-material/BeachAccess';
import LakeAccess from '@mui/icons-material/Rowing';
import ClubHouse from '@mui/icons-material/House';
import BoatRamp from '@mui/icons-material/DirectionsBoat';
import Lake from '@mui/icons-material/Waves';
import NatureIcon from '@mui/icons-material/Nature';
import House from '@mui/icons-material/House';
import DogParkIcon from '@mui/icons-material/Pets';
import SplashParkIcon from '@mui/icons-material/Nature';
import HikingIcon from '@mui/icons-material/DirectionsWalk';
import SportsGolfIcon from '@mui/icons-material/SportsGolf';
import SportsPickleIcon from '@mui/icons-material/SportsRugby';
import Shuffle from '@mui/icons-material/Shuffle';
import SportsHockeyIcon from '@mui/icons-material/SportsHockey';
import RugbyIcon from '@mui/icons-material/SportsRugby';

const config: any = {
  HOA_CONFIG_DESCRIPTION: 'All the configurations of the data fields in this HOA module will affect the selected organization',
  HOA_MAILS_BUCKET: 'hoaMails',
  baseUrl: '/app/hoa/',
  // baseUrl:'/app/hoa-dashboard/api',
  sideDrawerMenuItems: [
    'Municipalities', 'HOAs', 'Properties'
  ],
  sideDrawerMenuInboxItems: [
    'Mails', 'Emails', 'Documents'
  ],
  sideDrawerMenuTaskItems: [
    'PendingSource', 'PropertiesPendingTask'
  ],
  sideDrawerMenuCompletedTaskItems: [
    'PropertiesCompletedTask'
  ],
  sideDrawerMenuAdditionalItems: [
    'Requests', 'Webhook'
  ],
  sideDrawerMenuInvoicing: [
    'Analytics', 'Invoicing', 'InvoiceDataMapping'
  ],
  sideDrawerMenuSettings:[
    'DataFieldConfigurator'
  ],
  validMenuUrlParams: [
    'municipalities', 'municipality', 'hoas', 'hoa',
    'properties', 'property', 'mails', 'mail', 'invoicing',
    'requests', 'request', 'documents', 'document', 'pendingsource',
    'analytics', 'analytic', 'webhook', 'emails', 'datafieldconfigurator', 'propertiespendingtask', 'propertiescompletedtask', 'invoicedatamapping'
  ],
  clientValidMenuUrlParams: ['hoas', 'hoa','properties', 'property'],
  hoaTabTitles: [
    'Overview', 'Procedures','Amenities', 'Violation Regulation',
    'Documents', 'Properties', 'Change Log'
  ],
  municipalityTabTitles: [
    'Overview', 'Municipality Fees', 'Additional Details',
    'Change Log'
  ],
  propertyTabTitles: [
    'Overview', 'Violations & Invoices', 'Mails', 'Emails', 'Change Log'
  ],
  webhookTabTitles: [
    'Webhooks', 'Logs'
  ],
  changeLongActionsMuncipality: {
    'add': 'Add Municipality',
    'update': 'Update Municipality',
    'remove': 'Remove Municipality',
  },

  changeLongActionsHoa: {
    'add': 'Add HOA',
    'update': 'Update HOA',
    'remove': 'Remove HOA',
    'propertyAssigned': 'Property Assigned to HOA',
    'deleteProperty': 'Delete Property',
    'removeProperty': 'Property Removed from HOA',
    'clientAssigned': 'Organization Assigned to HOA'
  },

  changeLongActionsProperty: {
    'add': 'Add Property',
    'update': 'Update Property',
    'remove': 'Remove Property',
    'deleteHoa': 'Delete HOA',
    'assignedToMail': 'Mail assigned to property.',
    'unAssignedToMail': 'Mail removed from property.',
    'assignedToEmail': 'Email assigned to property.',
    'unAssignedToEmail': 'Email removed from property.'
  },

  changeLongActionsMail: {
    'add': 'Add Mail',
    'update': 'Update Mail',
    'remove': 'Remove Mail',
  },

  additionalType: {
    'First property addition': 'Property',
    'Subsequent Property addition': 'Property'
  },

  dashboard: {
    HOAs: {
      filterComponent: {
        title: 'HOAs',
        subTitle: 'View & manage all the recently added HOAs'
      },
      tableLayout: {
        title: ["HOA Name", "PMC", "Market", "City", "HOA Address", "No. of Properties", "Last Updated", "Type", ""],
        columns: ['name', 'propertyManager', 'market', 'city', 'address', 'numberOfProperties', 'updatedAt', 'masterHoaId', 'hover']
      }
    },
    Municipalities: {
      filterComponent: {
        title: 'Municipalities',
        subTitle: 'View & manage all the recently added municipalities.'
      },
      tableLayout: {
        title: ["City", "State", "Market", "Last Updated", ""],
        columns: ['city', 'state', 'market', 'updatedAt', "hover"]
      }
    },
    Properties: {
      filterComponent: {
        title: 'Properties',
        subTitle: 'View & manage all the recently added properties.'
      },
      tableLayout: {
        title: ["Property Address", "External ID", "City", "Organization", "Market", "Last Updated", "Tag", "Added By", ""],
        columns: ['fullAddress', 'hoaPropertyDetails', 'info', 'organizationName', 'hoaPropertyDetails', 'updatedAt', 'hoaId', 'addedBy', 'hover']
      }
    },
    Mails: {
      filterComponent: {
        title: 'Mails',
        subTitle: 'View & manage all the mails for properties.'
      },
      tableLayout: {
        title: ["checkbox", "Recipient Name", "Recipient Address", "Senders Name", "Senders Address", "Status", "Actual Receive Date", "Assigned Responsible", "SPS Document Type", "Platform Upload Date", "Last Updated Date", "ID", "Folder Name", "Organization", ""],
        columns: ["checkbox", 'sendTo', 'sendTo', 'sendFrom', 'sendFrom', 'status', 'mailServerTime', 'lastUpdatedBy', 'spsDocumentType', 'createdAt', 'updatedAt', 'objectId', 'folderName', 'organization', 'hover']
      }
    },
    Emails: {
      filterComponent: {
        title: 'Emails',
        subTitle: 'View & manage all the emails for properties.'
      },
      tableLayout: {
        title: ["checkbox", "Subject", "Sent From", "Status", "Assigned Responsible", "Actual Receive Date", "ID", "Platform Upload Date", "Last Updated Date", ""],
        columns: ['checkbox', 'subject', 'sendFrom', 'status', 'lastUpdatedBy', 'emailServerTime', 'objectId', 'createdAt', 'updatedAt', 'hover']
      }
    },
    Requests: {
      filterComponent: {
        title: 'Requests',
        subTitle: 'View & manage all the requests for HOAs & Properties.'
      },
      tableLayout: {
        title: ["Request Id","Request Type", "Description of Request", "Status", "Date", ""],
        columns: ['objectId','type', 'description', 'status', 'createdAt', 'hover']
      }
    },
    DataFieldConfigurator: {
      filterComponent: {
        title: 'DataFieldConfigurator', 
      },
      tableLayout: {
        title: ["Module Name", "Description", "Organization Name", "Last Updated", "Published Date", ""],
        columns: ['moduleName', 'description', "organizationName", 'lastUpdated', 'publishedDate', 'hover']
      }
    },
    Document: {
      filterComponent: {
        title: 'Documents',
        subTitle: 'View & manage all the document requests for HOAs & Properties.'
      },
      tableLayout: {
        title: ["Document ID", "Document", "HOA vendor ID", "External ID", "Document Type", "Date", "Status", "Added By", "Organization", ""],
        columns: ['objectId', 'documentName', 'hoaVendorID', 'externalID', 'documentType', 'dateStamp', 'status', 'addedBy', 'organization', 'hover']
      }
    },
    Webhook: {
      filterComponent: {
        title: 'Webhooks',
        subTitle: 'View & manage all the webhooks for organization.'
      },
      tableLayout: {
        title: ["ID", "Organization ID", "Type", "Event", "URL", ""],
        columns: ['objectId', 'organizationId', 'type', 'event', 'url', 'hover']
      }
    },
    TriggerNotificationLog: {
      tableLayout: {
        title: ["ID", "App Log Id", "Date", "Trigger Notification ID", "Status", ""],
        columns: ['objectId', 'appLogsId', 'createdAt', 'triggerNotificationId', 'status', 'hover']
      }
    },
    PropertiesModalTable: {
      filterComponent: {
        title: 'Properties',
        subTitle: 'View & manage all the recently added properties.'
      },
      tableLayout: {
        title: ["External ID", "Property Address", "City", "HOA Name", "Organization", "Market", ""],
        columns: ['hoaPropertyDetails', 'fullAddress', 'info', 'hoaName', 'organizationName', 'hoaPropertyDetails', 'hover']
      }
    },
    PendingSourceTable: {
      filterComponent: {
        title: 'Pending Source',
        subTitle: 'View & manage all the recently added source.'
      },
      tableLayout: {
        title: ["Source Type", "ID", "Recipient", "Senders", "Subject", "Status", "Date", "Organization", "SPS Document Type", ""],
        columns: ['sourceType', 'objectId', 'sendTo', 'sendFrom', 'subject', 'status', 'createdAt', 'organization', 'spsDocumentType', 'hover']
      }
    }
  },
  stateOptions: ['All', 'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
  frequencyOptions: ['Monthly', 'Bi-Monthly', 'Quarterly', 'Semi-Annually', 'Annually'],
  marketOptions: ['All', 'Charlotte', 'Las Vegas', 'Northern CA', 'Southern CA', 'Austin', 'Greensboro', 'Columbus', 'Tucson', 'Tampa', 'Atlanta', 'Raleigh', 'Reno', 'Dallas-Fort Worth', 'Indianapolis', 'Orlando', 'Columbia', 'Houston', 'San Antonio', 'Southeast Florida', 'Jacksonville', 'Nashville', 'Phoenix', 'Greenville'],
  amenityIcons: {
    'Gym': GymIcon,
    'Jacuzzi': Jacuzzi,
    'Pool': PoolIcon,
    'Park': Park,
    'Tennis Court': SportsTennis,
    'Soccer Field': SportsSoccer,
    'Lake': Lake,
    'Roller Hockey': SportsHockeyIcon,
    'Golf Course': GolfCourse,
    'Mini-Golf Course': GolfCourse,
    'Boat Ramp': BoatRamp,
    'Lake Access': LakeAccess,
    'Beach Access': BeachAccess,
    'Beache Access': BeachAccess, // This item should not be removed for supporting older hoas
    'Basketball Court': SportsBasketball,
    'Shuffleboard Court': Shuffle,
    'Walking Trail': Walk,
    'Volleyball Court': SportsVolleyball,
    'Baseball Diamond': SportsBaseball,
    'Club House': House,
    'Tot lot': NatureIcon,
    'Racquetball Court': SportsTennis,
    "Children's pool": PoolIcon,
    "Pickleball Court": SportsPickleIcon,
    "Dog Park": DogParkIcon,
    "Splash Park": SplashParkIcon,
    "Disc Golf Course": SportsGolfIcon,
    "Hiking Trail": HikingIcon,
    "Rugby Court": RugbyIcon,
  },
  grassTypes: [
    'Argentine Bahia',
    'Agropyron Cristatum',
    'Artificial Grass',
    'Bahia',
    'Bermuda',
    'Bermuda (Hybrid)',
    'Berkeley Sedge',
    'Buffalo Grass',
    'Carl',
    'Centipede',
    'Crested Wheatgrass',
    'Dormant Winter Grasses',
    'Emerald Centipede (Evermochloa Ophiuroidea)',
    'Fescue',
    'Fine Blade Fescue',
    'Fine Blade Rye',
    'Floratam',
    'Floridascape Plant Species',
    'Foerster Grass',
    'Fountain Grass (Pennesethus Setaceum)',
    'Festuca Arundinacea (Tall fescue)',
    'Grama Species',
    'Guif Vuhly',
    'Indiangrass',
    'Indian Ricegrass',
    'Kentucky Bluegrass',
    'Land Sea Qats',
    'Lolium Perenne',
    'Lawngrass',
    'Mexican Feathergrass',
    'Poa Pratensis',
    'Pampas Grass (Cortadena Selloana)',
    'Paspalum Grass',
    'Prairie Drop Seed',
    'Ryegrasses',
    'Sod',
    'Sprig',
    'Seville',
    'St. Augustine (Stenotaphrum Secundatum)',
    'Switchgrass',
    'Turf Grass',
    'Turf Grass(Water Conserving)',
    'Tens Beargrass',
    'Tiff Bermuda',
    'Vaiden Grass',
    'Winter Rye',
    'Zoysia',
  ],
  prohibitedVehicle: [
    {
      key: "Broken vehicles",
      label: "Broken vehicles",
      items: [
        {
          key: "Unregistered Vehicles",
          label: "Unregistered Vehicles",
        },
        {
          key: "Uninsured Vehicles",
          label: "Uninsured Vehicles",
        },
        {
          key: "Unlicensed Vehicles",
          label: "Unlicensed Vehicles",
        },
        {
          key: "Inoperative Vehicles",
          label: "Inoperative Vehicles",
        },
        {
          key: "Abandoned Vehicles",
          label: "Abandoned Vehicles",
        },
        {
          key: "Vehicles Covered with tarps",
          label: "Vehicles Covered with tarps",
        }
      ]
    },
    {
      key: "Non-Passenger",
      label: "Non-Passenger",
      items: [
        {
          key: "Snowmobiles",
          label: "Snowmobiles",
        },
        {
          key: "Motorcycles",
          label: "Motorcycles",
        },
        {
          key: "Mini-bikes",
          label: "Mini-bikes",
        },
        {
          key: "Autocycles",
          label: "Autocycles",
        },
        {
          key: "Mopeds",
          label: "Mopeds",
        },
        {
          key: "Motor scooters",
          label: "Motor scooters",
        },
        {
          key: "Dirt bikes",
          label: "Dirt bikes",
        },
        {
          key: "Four-wheelers",
          label: "Four-wheelers",
        },
        {
          key: "Bicycle, tricycle, or other wheeled toys",
          label: "Bicycle, tricycle, or other wheeled toys",
        },
        {
          key: "Non-motorized vehicles",
          label: "Non-motorized vehicles",
        },
        {
          key: "Golf carts",
          label: "Golf carts",
        },
        {
          key: "Go-karts",
          label: "Go-karts",
        },
        {
          key: "Dune buggies",
          label: "Dune buggies",
        },
        {
          key: "Mules",
          label: "Mules",
        },
        {
          key: "Off-road vehicles",
          label: "Off-road vehicles",
        },
        {
          key: "Hobby Vehicles",
          label: "Hobby Vehicles",
        },
      ]
    },
    {
      key: "Aircraft",
      label: "Aircraft",
      items: [
        {
          key: "Aircrafts",
          label: "Aircrafts",
        },
        {
          key: "Gliders",
          label: "Gliders",
        },
        {
          key: "Helicopters",
          label: "Helicopters",
        },
        {
          key: "Ultra Lights",
          label: "Ultra Lights",
        }
      ]
    },
    {
      key: "Other Category",
      label: "Other Category",
      items: [
        {
          key: "Trailers",
          label: "Trailers",
        },
        {
          key: "Boat Trailers",
          label: "Boat Trailers",
        },
        {
          key: "Campers",
          label: "Campers",
        },
        {
          key: "Buses",
          label: "Buses",
        },
        {
          key: "Mobile Homes",
          label: "Mobile Homes",
        },
        {
          key: "School Buses",
          label: "School Buses",
        },
        {
          key: "Recreational Vehicles",
          label: "Recreational Vehicles",
        },
        {
          key: "Limousines",
          label: "Limousines",
        },
        {
          key: "Artificially Extended Vehicles",
          label: "Artificially Extended Vehicles",
        },
        {
          key: "Racing vehicles",
          label: "Racing vehicles",
        },
      ]
    },
    {
      key: "Equipment",
      label: "Equipment",
      items: [
        {
          key: "Graders",
          label: "Graders",
        },
        {
          key: "Lawn Mowers",
          label: "Lawn Mowers",
        },
        {
          key: "Tractors",
          label: "Tractors",
        },
        {
          key: "Construction Machinery And Equipments",
          label: "Construction Machinery And Equipments",
        },
        {
          key: "Vessel Or Temporary Structures",
          label: "Vessel Or Temporary Structures",
        }
      ]
    },
    {
      key: "Waterborne",
      label: "Waterborne",
      items: [
        {
          key: "Watercrafts",
          label: "Watercrafts",
        },
        {
          key: "Boats",
          label: "Boats",
        },
        {
          key: "Jet-Skis",
          label: "Jet-Skis",
        },
        {
          key: "Water Scooters",
          label: "Water Scooters",
        },
        {
          key: "Kayaks",
          label: "Kayaks",
        },
        {
          key: "Canoes",
          label: "Canoes",
        },
        {
          key: "Hovercrafts",
          label: "Hovercrafts",
        },
        {
          key: "Motorboats",
          label: "Motorboats",
        },
        {
          key: "Houseboats",
          label: "Houseboats",
        },
        {
          key: "Marine Crafts",
          label: "Marine Crafts",
        },
      ]
    },
    {
      key: "Vans and vehicles ",
      label: "Vans and vehicles",
      items: [
        {
          key: "Vans",
          label: "Vans",
        },
        {
          key: "Cargo Vans",
          label: "Cargo Vans",
        },
        {
          key: "Mini-Vans",
          label: "Mini-Vans",
        },
        {
          key: "Moving Vans",
          label: "Moving Vans",
        },
        {
          key: "Sport Utility Vehicles",
          label: "Sport Utility Vehicles",
        },
        {
          key: "Pickup Coaches",
          label: "Pickup Coaches",
        },
        {
          key: "Wagons",
          label: "Wagons",
        },
      ]
    },
    {
      key: "Mini Motor Homes and vehicles",
      label: "Mini Motor Homes and vehicles",
      items: [
        {
          key: "Motor Homes",
          label: "Motor Homes",
        }
      ]
    },
    {
      key: "Trucks and vehicles",
      label: "Trucks and vehicles",
      items: [
        {
          key: "Trucks (weight capacity)",
          label: "Trucks (weight capacity)",
        },
        {
          key: "Trucks (wheel capacity)",
          label: "Trucks (wheel capacity)",
        },
        {
          key: "Trucks (length capacity)",
          label: "Trucks (length capacity)",
        },
        {
          key: "Trucks",
          label: "Trucks",
        },
        {
          key: "Pick-Up Trucks",
          label: "Pick-Up Trucks",
        },
        {
          key: "Camper Rig Off Truck",
          label: "Camper Rig Off Truck",
        },
        {
          key: "Jeep Trucks",
          label: "Jeep Trucks",
        },
        {
          key: "Heavy Duty Trucks",
          label: "Heavy Duty Trucks",
        },
      ]
    },
    {
      key: "Misc",
      label: "Misc",
      items: [
        {
          key: "Vehicles (weight capacity)",
          label: "Vehicles (weight capacity)",
        },
        {
          key: "Vehicles (length capacity)",
          label: "Vehicles (length capacity)",
        },
        {
          key: "Yard vehicles",
          label: "Yard vehicles",
        },
        {
          key: "Passenger Vehicles",
          label: "Passenger Vehicles",
        },
        {
          key: "Automobiles",
          label: "Automobiles",
        }
      ]
    },
  ],
  assignMailDocumentTypes: [
    "HOA violations",
    "HOA dues",
    "City Violation",
    "Fire alarm testing",
    "Fumigation/pet control events",
    "Parking-related changes",
    "Water/elevator shut-off changes",
    "HOA emergency contact changes",
    "Pool rule changes",
    "Pet-related notices",
    "Emergency notices",
    "Construction notices",
    "Security-related notices",
    "Other"
  ],
  documentStatusItem: ['All', 'Pending', 'Processing', 'Closed'],
  mailMenuItem: [
    {
      key: 'Assigned',
      value: 'Assigned',
      color: '#FFECB3',
      menuItemColor: "#FFD54F"
    },
    {
      key: 'Processing',
      value: 'Processing',
      color: '#EDE7F6',
      menuItemColor: "#9575CD"
    },
    {
      key: 'Unassigned',
      value: 'Unassigned',
      color: '#E8F5EC',
      menuItemColor: "#81C784"
    },
    {
      key: 'Non-assignable',
      value: 'Non-assignable',
      color: '#DA9890',
      menuItemColor: "#DA9890"
    },
    /* {
      key: 'Pending Assignment',
      value: 'Pending Assignment',
      color: '#DA9890',
      menuItemColor: "#C05142"
    } */
  ],
  documentMenuItem: [
    {
      key: 'Pending',
      value: 'Pending',
      color: '#FFECB3',
      menuItemColor: "#FFD54F"
    },
    {
      key: 'Processing',
      value: 'Processing',
      color: '#EDE7F6',
      menuItemColor: "#9575CD"
    },
    {
      key: 'Closed',
      value: 'Closed',
      color: '#E8F5EC',
      menuItemColor: "#81C784"
    },
  ],
  requestMenuItem: [
    {
      key: 'Pending',
      value: 'Pending',
      color: '#FFECB3',
      menuItemColor: "#FFD54F"
    },
    {
      key: 'Processing',
      value: 'Processing',
      color: '#EDE7F6',
      menuItemColor: "#9575CD"
    },
    {
      key: 'Closed',
      value: 'Closed',
      color: '#E8F5EC',
      menuItemColor: "#81C784"
    },
  ],
  timeLines: ['Years', 'Months', 'Weeks', 'Days'],
  sizes: ['CM', 'Inch'],
  canopySizes: ['CM', 'Inch', 'Feet'],

  alterationOptions: {
    "Painting": "regulationsOfPainting",
    "Fence": "regulationsOfFence",
    "Lighting": "regulationsOfLighting",
    "Garage/Driveway": "regulationsOfGarageDriveway",
    "Paved Surface": "regulationsOfPavedSurface",
    "Swimming Pool": "regulationsOfSwimmingPool",
    "Playscape": "regulationsOfPlayscape",
    "Secondary Structure": "regulationsOfSecondaryStructure",
    "Antennas and Satellite Dishes": "regulationsOfAntennasSatelliteDishes",
    "Mailboxes": "regulationsOfMailboxes",
    "Oiling, Excavations and Mining/ Rainwater Harvesting System": "regulationsOfOilingExcavationsMiningRainwaterHarvestingSystem",
    "Flags and Flag poles": "regulationsOffLagsFlagPoles",
    "Water Features/ Wells and Septic Tanks": "regulationsOfWaterFeaturesWellsSepticTanks",
    "Siding and Exterior Cladding": "regulationsOfSidingExteriorCladding",
    "Windows / Sun Screens / Screen Doors": "regulationsOfWindowsSunScreensScreenDoors",
    "Security Devices": "regulationsOfSecurityDevices",
    "Courtyard": "regulationsOfCourtyard",
    "Lawn Art & Outdoor Furniture": "regulationsOflLawnArtOutdoorFurniture",
    "Storage Tanks": "regulationsOfStorageTanks",
    "Solar Panels": "regulationsOfSolarPanels",
    "Air Conditioning": "regulationsOfAirConditioning",
  },
  maintenanceOptions: {
    "Broken/Deteriorating Structure": "regulationsOfBrokenDeterioratingStructure",
    "Roof/Soffit/Fascia": "regulationsOfRoofSoffitFascia",
    "Outdoor Kitchen": "regulationsOfOutdoorKitchen",
    "Patio & Deck": "regulationsOfPatioDeck",
    "Windows & Awnings": "regulationsOfWindowsAwnings",
    "Pressure Washing": "regulationsOfPressureWashing",
    "Irrigation Systems": "regulationsOfIrrigationSystems",
    "Drainage": "regulationsOfDrainage",
    "Displaying signs, posters, billboards or advertising": "regulationsOfSignsAdvertising",
    "Yard Lights": "regulationsOfYardLights"
  },

  violationRegulations: {
    'Tree alteration and planting': 'regulationsOfAlterationAndPlantingOfTrees',
    'Pruning and trimming': 'regulationsOfPruningTrimming',
    'Vegetation obstructing the view for other residents': 'regulationsOfVegetationObstructingResidents',
    'Fertilization': 'regulationsOfFertilization',
    'Irrigation maintenance and stain prevention': 'regulationsOfIrrigationMaintenanceAndStainPrevention',
    'Mulch Replenishing': 'regulationsOfMulchReplenishing',
    'Trash can on driveway, balcony, or patio': 'regulationsOfTrashCansDrivewayBalconyOrPatio',
    'Maintenance of Trash': 'regulationsOfMaintenanceTrashCans',
    'Outside Burning of Trash': 'regulationsOfOutsideBurningTrash',
    'Repair and Maintenance of Cars': 'regulationsOfRepairMaintenanceOfCars',
    'Garage Sales': 'regulationsOfGarageSales',
    'Commercial Vehicles': 'typesOfCommercialVehicle',
    'Animal Regulations and Commercial Use': 'regulationOfAnimalsCommercial',
    'Dog Houses': 'regulationsOfDogHouses',
    'Discharge of Firearms': 'regulationsOfDischargeOfFirearms',
    'Celebration of certain festivals': 'instructionsOfCelebrationCertainFestivals',
    "Broken/Deteriorating Structure": "regulationsOfBrokenDeterioratingStructure",
    "Roof/Soffit/Fascia": "regulationsOfRoofSoffitFascia",
    "Outdoor Kitchen": "regulationsOfOutdoorKitchen",
    "Patio & Deck": "regulationsOfPatioDeck",
    "Windows & Awnings": "regulationsOfWindowsAwnings",
    "Pressure Washing": "regulationsOfPressureWashing",
    "Irrigation Systems": "regulationsOfIrrigationSystems",
    "Drainage": "regulationsOfDrainage",
    "Displaying signs, posters, billboards or advertising": "regulationsOfSignsAdvertising",
    "Yard Lights": "regulationsOfYardLights",
    "Painting": "regulationsOfPainting",
    "Fence": "regulationsOfFence",
    "Lighting": "regulationsOfLighting",
    "Garage/Driveway": "regulationsOfGarageDriveway",
    "Paved Surface": "regulationsOfPavedSurface",
    "Swimming Pool": "regulationsOfSwimmingPool",
    "Playscape": "regulationsOfPlayscape",
    "Secondary Structure": "regulationsOfSecondaryStructure",
    "Antennas and Satellite Dishes": "regulationsOfAntennasSatelliteDishes",
    "Mailboxes": "regulationsOfMailboxes",
    "Oiling, Excavations and Mining/ Rainwater Harvesting System": "regulationsOfOilingExcavationsMiningRainwaterHarvestingSystem",
    "Flags and Flag poles": "regulationsOffLagsFlagPoles",
    "Water Features/ Wells and Septic Tanks": "regulationsOfWaterFeaturesWellsSepticTanks",
    "Siding and Exterior Cladding": "regulationsOfSidingExteriorCladding",
    "Windows / Sun Screens / Screen Doors": "regulationsOfWindowsSunScreensScreenDoors",
    "Security Devices": "regulationsOfSecurityDevices",
    "Courtyard": "regulationsOfCourtyard",
    "Lawn Art & Outdoor Furniture": "regulationsOflLawnArtOutdoorFurniture",
    "Storage Tanks": "regulationsOfStorageTanks",
    "Solar Panels": "regulationsOfSolarPanels",
    "Air Conditioning": "regulationsOfAirConditioning",
  },
  preferredViolationRemediation: {
    "Portal": "additionalInfoOfPortal",
    "Email": "additionalInfoOfEmail",
    "Other": "additionalInfoOfOther"
  },
  violationStageNotices: ['Courtesy', '1st Warning', '2nd Warning', 'Hearing', 'Final Warning', 'Legal', 'Lien', 'Resolved'],
  tagTypes: ['Hoa', 'Municipality', 'Property'],
  hoaEvents: ['Add HOA', 'Update HOA'],
  municipalityEvents: ['Add Municipality', 'Update Municipality'],
  propertyEvents: ['Add Property', 'Update Property'],

  propertyLinkStatus: ['All', 'Linked', 'Unlinked'],

  fineFrequency: ['Daily', 'Weekly', 'Biweekly', 'Monthly', 'Every 5 days', 'Every 10 days', 'Every 15 days', 'One time'],
  violationCategory: {
    'ARC Forms': ['Architectural'],
    'Fence / Gate': ['Fence or Gate Maintenance','Garage or Garage Door'],
    'Gutters': ['Gutters Clean or Repair'],
    'Holiday Decorations': ['Decorations'],
    'Leasing Restriction': ['Use Restrictions'],
    'Lighting': ['Outdoor Lights'],
    'Mailbox': ['Mailbox Repair'],
    'Other': ['Other - Watering on Wrong day','Other Violations'],
    'Paint': ['Exterior Paint'],
    'Permits / Licensing': ['Permits or Licenses'],
    'Pressure Wash': ['Power Washing'],
    'Pool': ['Pool Access'],
    'Trash Containers': ['Trash or Garbage Cans'],
    'Unpaid Assessments / Fees': ['Assessments or Fees'],
    'Window / Blinds': ['Window-Blinds-Shutters'],
    'Landscaping': ['Weeds', 'Mulch', 'Flower Beds', 'Lawn', 'Plants', 'Shrubs', 'Berm', 'Edging','Sod', 'Leaves'],
    'Nuisance': ['Pet', 'Unsightly Items - Basketball Hoop', 'Unsightly Items - Grill', 'Unsightly Items - Trampoline', 'Unsightly Items - Improper Storage', 'Unsightly Items - Toys', 'Unsightly Items - Signage'],
    'Parking': ['General Parking Violation', 'Prohibited Vehicle', 'Boat', 'Inoperable Vehicle', 'Trailer', 'Street Parking', 'Commercial Vehicle', 'Parking in Unauthorized Areas'],
    'Tree Trimming': ['Tree', 'Dead Tree', 'Missing Tree'],
    'Rental Registration': ['Rental Registrations'],
    'Signs': ['Sign Regulations'],
  },
  stateNameAbbreviations: [
    {
      "name": "Alabama",
      "abbreviation": "AL"
    },
    {
      "name": "Alaska",
      "abbreviation": "AK"
    },
    {
      "name": "American Samoa",
      "abbreviation": "AS"
    },
    {
      "name": "Arizona",
      "abbreviation": "AZ"
    },
    {
      "name": "Arkansas",
      "abbreviation": "AR"
    },
    {
      "name": "California",
      "abbreviation": "CA"
    },
    {
      "name": "Colorado",
      "abbreviation": "CO"
    },
    {
      "name": "Connecticut",
      "abbreviation": "CT"
    },
    {
      "name": "Delaware",
      "abbreviation": "DE"
    },
    {
      "name": "District Of Columbia",
      "abbreviation": "DC"
    },
    {
      "name": "Federated States Of Micronesia",
      "abbreviation": "FM"
    },
    {
      "name": "Florida",
      "abbreviation": "FL"
    },
    {
      "name": "Georgia",
      "abbreviation": "GA"
    },
    {
      "name": "Guam",
      "abbreviation": "GU"
    },
    {
      "name": "Hawaii",
      "abbreviation": "HI"
    },
    {
      "name": "Idaho",
      "abbreviation": "ID"
    },
    {
      "name": "Illinois",
      "abbreviation": "IL"
    },
    {
      "name": "Indiana",
      "abbreviation": "IN"
    },
    {
      "name": "Iowa",
      "abbreviation": "IA"
    },
    {
      "name": "Kansas",
      "abbreviation": "KS"
    },
    {
      "name": "Kentucky",
      "abbreviation": "KY"
    },
    {
      "name": "Louisiana",
      "abbreviation": "LA"
    },
    {
      "name": "Maine",
      "abbreviation": "ME"
    },
    {
      "name": "Marshall Islands",
      "abbreviation": "MH"
    },
    {
      "name": "Maryland",
      "abbreviation": "MD"
    },
    {
      "name": "Massachusetts",
      "abbreviation": "MA"
    },
    {
      "name": "Michigan",
      "abbreviation": "MI"
    },
    {
      "name": "Minnesota",
      "abbreviation": "MN"
    },
    {
      "name": "Mississippi",
      "abbreviation": "MS"
    },
    {
      "name": "Missouri",
      "abbreviation": "MO"
    },
    {
      "name": "Montana",
      "abbreviation": "MT"
    },
    {
      "name": "Nebraska",
      "abbreviation": "NE"
    },
    {
      "name": "Nevada",
      "abbreviation": "NV"
    },
    {
      "name": "New Hampshire",
      "abbreviation": "NH"
    },
    {
      "name": "New Jersey",
      "abbreviation": "NJ"
    },
    {
      "name": "New Mexico",
      "abbreviation": "NM"
    },
    {
      "name": "New York",
      "abbreviation": "NY"
    },
    {
      "name": "North Carolina",
      "abbreviation": "NC"
    },
    {
      "name": "North Dakota",
      "abbreviation": "ND"
    },
    {
      "name": "Northern Mariana Islands",
      "abbreviation": "MP"
    },
    {
      "name": "Ohio",
      "abbreviation": "OH"
    },
    {
      "name": "Oklahoma",
      "abbreviation": "OK"
    },
    {
      "name": "Oregon",
      "abbreviation": "OR"
    },
    {
      "name": "Palau",
      "abbreviation": "PW"
    },
    {
      "name": "Pennsylvania",
      "abbreviation": "PA"
    },
    {
      "name": "Puerto Rico",
      "abbreviation": "PR"
    },
    {
      "name": "Rhode Island",
      "abbreviation": "RI"
    },
    {
      "name": "South Carolina",
      "abbreviation": "SC"
    },
    {
      "name": "South Dakota",
      "abbreviation": "SD"
    },
    {
      "name": "Tennessee",
      "abbreviation": "TN"
    },
    {
      "name": "Texas",
      "abbreviation": "TX"
    },
    {
      "name": "Utah",
      "abbreviation": "UT"
    },
    {
      "name": "Vermont",
      "abbreviation": "VT"
    },
    {
      "name": "Virgin Islands",
      "abbreviation": "VI"
    },
    {
      "name": "Virginia",
      "abbreviation": "VA"
    },
    {
      "name": "Washington",
      "abbreviation": "WA"
    },
    {
      "name": "West Virginia",
      "abbreviation": "WV"
    },
    {
      "name": "Wisconsin",
      "abbreviation": "WI"
    },
    {
      "name": "Wyoming",
      "abbreviation": "WY"
    }
  ],
  userRoles: {
    Admin: 'admin',
    Client: 'client',
    Developer: 'developer',
    Officer: 'officer',
    OrganizationUser: 'organization-user',
    Css: 'css',
    Unknown: 'unknown'
  },
  billableItemModalDocumentType: ["CCNR Document", "By-laws Document", "Rules and Restrictions", "Articles of Incorporation", "HOA Tenant or Lease Registration Form", "Other Documents"],
  
  leasingRestrictionsAndRegulationsKeywords: ['No leasing', 'Leasing restricted', 'No owner shall lease or rent',
    'No owner may lease', 'No home may be leased', 'No owner may rent', 'No home may be rented',
    'No owner shall lease', 'No owner shall rent', 'No rentals', 'No rental organizations', 
    'No rental institutions', 'No rental companies',

    'Leasing cap', 'Rental cap (from x% to y%)', 'Owner occupied for # years', 'Owning multiple rental homes',

    'Owner occupancy required', 'Owner must occupy', 'Must own for # years before leasing',

    'Lease must be approved', 'No lease may be for a term of less than', 'Leases must be for a term of',
    'Lease approval', 'Lease review', 'Rental application', 'Minimum lease term', 
    'Lease application fee', 'Rental approval fee', 'Leasing permit', 'Grandfathered',
    'Age restrictions'
  ],
  leasingRestrictionsAndRegulationsCategory: {
    'No leasing': 'No Leasing',
    'Leasing restricted': 'No Leasing',
    'No owner shall lease or rent': 'No Leasing',
    'No owner may lease': 'No Leasing',
    'No home may be leased': 'No Leasing',
    'No owner may rent': 'No Leasing',
    'No home may be rented': 'No Leasing',
    'No owner shall lease': 'No Leasing',
    'No owner shall rent': 'No Leasing',
    'No rentals': 'No Leasing',
    'No rental organizations': 'No Leasing',
    'No rental institutions': 'No Leasing',
    'No rental companies': 'No Leasing',

    'Leasing cap': 'Limit Owned Rental Units',
    'Rental cap (from x% to y%)': 'Limit Owned Rental Units',
    'Owner occupied for # years': 'Limit Owned Rental Units',
    'Owning multiple rental homes': 'Limit Owned Rental Units',

    'Owner occupancy required': 'Owner Occupancy',
    'Owner must occupy': 'Owner Occupancy',
    'Must own for # years before leasing': 'Owner Occupancy',

    'Lease must be approved': 'Lease Review',
    'No lease may be for a term of less than': 'Lease Review',
    'Leases must be for a term of': 'Lease Review',
    'Lease approval': 'Lease Review',
    'Lease review': 'Lease Review',
    'Rental application': 'Lease Review',
    'Minimum lease term': 'Lease Review',
    'Lease application fee': 'Lease Review',
    'Rental approval fee': 'Lease Review',
    'Leasing permit': 'Lease Review',
    'Grandfathered': 'Lease Review',
    'Age restrictions': 'Lease Review'
  },
  hoaAmenityPaymentMethod: ['Cheque', 'Online Payment', 'Credit Card', 'Debit Card', 'ACH', 'Venmo', 'Zelle'],
  //New ID should be added when a new organization is added in HOA. (This hardcoded ID should be removed in future)
  billableOrgIds: ['XhZBTB9mDM', 'CSMdHBUJEj', 'ZhgtR8zB1O', 'cSzprl5nZN', 'pxTYpCVAaA', 'iuikX4KxzU', '7pwaye6Zjw', 'S4TZmC9uNE'],
  hoaOrganizations: [
    {
      name: 'Tricon',
      id: 'XhZBTB9mDM'
    },
    {
      name: 'HPA',
      id: 'cSzprl5nZN'
    },
    {
      name: 'Bridge Homes',
      id: 'iuikX4KxzU'
    },
    {
      name: 'TestForTest',
      id: 'CSMdHBUJEj'
    },
    {
      name: 'Dhaka Test Organization',
      id: 'ZhgtR8zB1O'
    },
    {
      name: 'HOA',
      id: 'pxTYpCVAaA'
    },
    {
      name: 'Bridge Homes - Test',
      id: '7pwaye6Zjw'
    },
    {
      name: 'Tricon - Test',
      id: 'S4TZmC9uNE'
    }
  ],
  hoaClientInfoFieldName: {
    'Tricon': 'Vendor ID',
    'HPA': 'Vendor ID',
    'Bridge Homes': 'Vendor ID',
    'Dhaka Test Organization': 'V ID',
    'HOA': 'HOA Vendor ID',
    'Bridge Homes - Test': 'Vendor ID',
    'Tricon - Test': 'Vendor ID'
  },
  documentAddedByOptions: [
    {
      id: 1,
      name: 'Tricon'
    },
    {
      id: 2,
      name: 'HPA'
    },
    {
      id: 5,
      name: 'Bridge Homes'
    },
    {
      id: 3,
      name: 'Internal'
    },
    {
      id: 4,
      name: 'External'
    },
    {
      id: 5,
      name: 'External Tricon'
    },
  ]
}
export default config;
